import api from '../utils/api';

// Fetch all grades
export const getAllGrades = async (headers) => {
  try {
    const response = await api.get('/api/grades', headers);
    console.log('Fetched grades response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching grades:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific grade by ID
export const getGradeById = async (id, headers) => {
  try {
    const response = await api.get(`/api/grades/${id}`, headers);
    console.log("grade by id", response.data)
    return response.data;
  } catch (error) {
    console.error(`Error fetching grade with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new grade
export const createGrade = async (gradeData, headers) => {
  try {
    const response = await api.post('/api/grades', gradeData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating grade:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing grade
export const updateGrade = async (id, gradeData, headers) => {
  try {
    const response = await api.put(`/api/grades/${id}`, gradeData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating grade with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a grade
export const deleteGrade = async (id, headers) => {
  try {
    const response = await api.delete(`/api/grades/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting grade with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch grades for a specific student
export const getGradesForStudent = async (studentId, headers) => {
  try {
    const response = await api.get(`/api/grades/student/${studentId}`, headers);
    console.log("fetchGradesForStudent", response.data)
    return response.data;
  } catch (error) {
    console.error(`Error fetching grades for student with ID ${studentId}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch grades for a specific assessment
export const getGradesForAssessment = async (assessmentId, headers) => {
  try {
    const response = await api.get(`/api/grades/assessment/${assessmentId}`, headers);
    console.log("fetchGradesForAssessment", response.data)
    return response.data;
  } catch (error) {
    console.error(`Error fetching grades for assessment with ID ${assessmentId}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
